// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../src-custom-solutions/president-election/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".swiper-container{position:relative}@media(max-width:767.98px){.swiper-container>.swiper-button-next,.swiper-container>.swiper-button-prev{display:none}}.swiper-container .swiper{overflow:clip;overflow-y:visible}", ""]);
// Exports
module.exports = exports;
